<template>
  <div
    v-if="show"
    class="bodega-perfecta"
    :class="variantClass"
    role="status"
    :aria-label="ariaLabel"
  >
    <div class="bodega-perfecta__content">
      <i class="bodega-perfecta__icon ni ni-building"></i>
      <span class="bodega-perfecta__text">BODEGA PERFECTA</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BodegaPerfecta',
  props: {
    /**
     * Controla si la banda se muestra o no
     * Se debe pasar el valor de clientePerfecto (1 = mostrar, 0 = ocultar)
     */
    show: {
      type: [Boolean, Number],
      default: false,
      validator: (value) => {
        // Acepta true/false o 1/0
        return typeof value === 'boolean' || value === 0 || value === 1;
      }
    },
    /**
     * Variante de la banda:
     * 'horizontal-top' - Banda horizontal en la parte superior
     * 'vertical-left' - Banda vertical en el lado izquierdo
     */
    variant: {
      type: String,
      default: 'horizontal-top',
      validator: (value) => {
        return ['horizontal-top', 'vertical-left'].includes(value);
      }
    },
    /**
     * Texto personalizado para el aria-label (accesibilidad)
     */
    ariaLabel: {
      type: String,
      default: 'Cliente marcado como bodega perfecta'
    }
  },
  computed: {
    variantClass() {
      return `bodega-perfecta--${this.variant}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.bodega-perfecta {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-family: 'Poppins', sans-serif;
  position: absolute;
  z-index: 100;

  &__content {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__icon {
    font-size: 16px;
    opacity: 0.95;
  }

  &__text {
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    opacity: 0.95;
    white-space: nowrap;
  }

  // Variante: Banda horizontal superior
  &--horizontal-top {
    top: 0;
    left: 0;
    right: 0;
    height: 36px;
    flex-direction: row;
    border-radius: 10px 10px 0 0;

    .bodega-perfecta__content {
      flex-direction: row;
    }
  }

  // Variante: Banda vertical izquierda
  &--vertical-left {
    top: 0;
    left: 0;
    bottom: 0;
    width: 36px;
    flex-direction: column;
    writing-mode: vertical-rl;
    text-orientation: mixed;
    border-radius: 10px 0 0 10px;

    .bodega-perfecta__content {
      flex-direction: column-reverse;
      transform: rotate(180deg);
    }

    .bodega-perfecta__icon {
      transform: rotate(90deg);
    }
  }
}

// Estilos responsivos
@media (max-width: 768px) {
  .bodega-perfecta {
    &__text {
      font-size: 10px;
      letter-spacing: 1px;
    }

    &__icon {
      font-size: 14px;
    }

    &--horizontal-top {
      height: 32px;
    }

    &--vertical-left {
      width: 32px;
    }
  }
}

// Alternativa de colores (puedes cambiar el degradado si lo deseas)
// Opción 1: Azul/Morado claro
.bodega-perfecta.bodega-perfecta--light {
  background: linear-gradient(135deg, #a8b5ff 0%, #c5a3d8 100%);
}

// Opción 2: Azul sólido
.bodega-perfecta.bodega-perfecta--solid-blue {
  background: #5e72e4;
}

// Opción 3: Morado/Rosa
.bodega-perfecta.bodega-perfecta--purple {
  background: linear-gradient(135deg, #667eea 0%, #f093fb 100%);
}
</style>
